import React, { useState } from 'react';
import {
  DockviewApi,
  DockviewPanelApi,
  IDockviewPanelProps,
  IDockviewPanelHeaderProps, 
  DockviewDefaultTab
} from 'dockview';
import DocEditor from '@/components/doceditor/index';
import ExcelSheet from '@/components/excelsheet';
import {IconPointFilled, IconSunLow, IconCoins, IconAutomaticGearbox, IconClock, IconInfoCircle} from '@tabler/icons-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"


export const tabcomponents = {
    tab_1: (props: IDockviewPanelHeaderProps) => {
      const api: DockviewPanelApi  = props.api;
      const containerApi: DockviewApi  = props.containerApi;
  
      return <div>{/** logic */}</div>
    },

    tab_2: (props: IDockviewPanelHeaderProps) => {
      return <div>{/** logic */}</div>
    },

    custom: (props: IDockviewPanelHeaderProps) => {
        const onContextMenu = (event: React.MouseEvent) => {
            event.preventDefault();
        };
        return <DockviewDefaultTab onContextMenu={onContextMenu} hideClose={true} {...props} />;
    },
  };

export const components = {
    properties: (props: IDockviewPanelProps<{ myValue: string }>) => {
        const [title, setTitle] = React.useState<string>(props.api.title ?? '');
        const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            setTitle(event.target.value);
        };
        const onClick = () => {
            props.api.setTitle(title);
        };
        return (
          <div className="p-4">
            <p className="text-lg font-medium">{props.api.title}</p>

            <p className="flex flex-row p-1 ">
              {" "}
              <IconAutomaticGearbox size={16} className="mt-1 me-1 " /> Triggered by
            </p>
            <p className="mb-4 text-sm">Nursid Ansari</p>
            <p className="flex flex-row p-1 ">
              {" "}
              <IconSunLow size={14} className="my-1.5 me-1" /> Status
            </p>

            <p className="pb-4">
              <span className="flex flex-row border rounded-lg px-1 py-1 text-xs w-20">
                <IconPointFilled size={16} color="blue" /> Finished
              </span>
            </p>

            <p className="flex flex-row text-sm">
              <IconClock size={16} className="my-1 me-1" /> Date created
            </p>
            <p className="text-xs mb-2">Oct 23 2024 @ 11:03 AM</p>


            <p className="flex flex-row p-1 text-md">
              <IconCoins size={16} className="mt-1 me-1 text-gray-500 " /> Credit  
            </p>

            <p className="flex flex-row p-1 mb-2">
              20.00 
              
              <TooltipProvider >
              <Tooltip >
                <TooltipTrigger><IconInfoCircle size={16} className='ml-1 mt-1 hover:cursor-pointer text-gray-500'  /></TooltipTrigger>
                <TooltipContent className='w-96'> 
                  <p>This is does not include cost of your subAgent tasks, but does it include the base cost of calling your subAgents. </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>

              
              
            </p>

           <div className='p-2'> 
              <p className="text-lg font-medium">Schedule</p>
              <p className="text-sm">No scheduled actions</p>
           </div>

           <div className='p-2'> 
              <p className="text-lg font-medium">Connected tools</p>
              <p className="text-sm">No tools Connected</p>
           </div>

           <div className='p-2'> 
              <p className="text-lg font-medium">Connected agents</p>
              <p className="text-sm">No Agent Connected</p>
           </div>

          </div>
        );
    },

    document: (props: IDockviewPanelProps<{ properties: string, setProperties: React.Dispatch<React.SetStateAction<string>> }>) => {
        return (
          <DocEditor/>  
        );
    },

    excel: (props: IDockviewPanelProps<{ properties: string, setProperties: React.Dispatch<React.SetStateAction<string>> }>) => {
        return (
          <ExcelSheet/>
        );
    },

    workspace: (props: IDockviewPanelProps<{ properties: string, setProperties: React.Dispatch<React.SetStateAction<string>> }>) => {
        return (
          <>
          work space file
          </>
        );
    },

};